import React from "react";

import moment from "moment";

import API_URLS from "constants/apis.url";
import { landingPageStrings } from "constants/constantStrings";

import "./footer.scss";

const Footer = () => {
  const handleCookieClick = () => {
    if (window.truste && window.truste.eu && window.truste.eu.clickListener) {
      window.truste.eu.clickListener();
    }
  };

  return (
    <div className="footer">
      <div className="footer-link-container">
        <a className="footer-link" href={API_URLS.dupontUrl} target="_blank" rel="noopener noreferrer">
          {landingPageStrings.dupontTitle}
        </a>
        <div className="footer-line">|</div>
        <a className="footer-link" href={API_URLS.privacyUrl} target="_blank" rel="noopener noreferrer">
          {landingPageStrings.privacy}
        </a>
        <div className="footer-line">|</div>
        <a className="footer-link" href={API_URLS.termsOfUse} target="_blank" rel="noopener noreferrer">
          {landingPageStrings.legalNotices}
        </a>
        <div className="footer-line">|</div>
        <a className="footer-link" onClick={handleCookieClick}>
          {landingPageStrings.cookiePreferences}
        </a>
      </div>
      <div className="disclamier-container">{landingPageStrings.disclamierText.replace("%y", moment().year())}</div>
    </div>
  );
};

export default Footer;
